const TEST_ID = {
  ADMIN_TAB_SAVE_FORM_BUTTON: 'admin-tab__save-form-button'
};
export default TEST_ID;